import script from "./CoursePurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoursePurchase.vue?vue&type=script&setup=true&lang=ts"

import "./CoursePurchase.vue?vue&type=style&index=0&id=f9c1869a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9c1869a"]])

export default __exports__